__turbopack_context__.v({
  "content": "aLg1iG_content",
});
